import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useAuthStore from "../../store/authStore";

import { DEFAULT_LITIGATION_PAGE, litigrationPages } from "../../utils/LitigrationConstants";

const redirectToLitigrationLanding = (landing = "/") => {
  let landingRoute = DEFAULT_LITIGATION_PAGE;

  for (let i = 0; i < litigrationPages?.length; i++) {
    const { key, route } = litigrationPages[i];

    if (landing === key) {
      landingRoute = route;
      break;
    }
  }

  return landingRoute;
};

export default function LitigrationLandingRedirect() {
  const userData = useAuthStore((state) => state.userData);
  const history = useHistory();

  useEffect(() => {
    history.push(redirectToLitigrationLanding(userData?.settings?.landing_page));
  }, [userData?.settings?.landing_page]);

  return null; // or <></>
}
